import { IS_DEBUG } from "./_constants";

import HomeApp from "./_HomeApp";

if (IS_DEBUG) {
  console.log("index.ts");
}

(window as any).homeApp = new HomeApp();
